<template>
  <FilterDetailPopover
    :title="title"
    :is-display-only="isDisplayOnly"
    :key-name="keyName"
    @hide="popoverHide"
    @show="popoverShow"
  >
    <template #reference>
      <BLayout
        align-center
      >
        <BListItem>
          <template #header>
            <div>{{ title }}</div>
          </template>
          <div>{{ value }}</div>
        </BListItem>
      </BLayout>
    </template>
    <div>
      <BInput
        ref="bInput"
        v-model="inputItem"
        :placeholder="$t('general.search.placeholder')"
      />
    </div>
  </FilterDetailPopover>
</template>

<script>
import lodash from 'lodash';
import FilterDetailPopover from '@/components/organisms/user/leadList/filter/FilterDetailPopover.vue';

export default {
  components: {
    FilterDetailPopover,
  },
  props: {
    leadListFilterParams: {
      type: Object,
      default () {
        return {};
      },
    },
    isDisplayOnly: {
      type: Boolean,
      default: false,
    },
    keyName: {
      type: String,
      required: true,
    },
  },
  emits: [
    'hide',
  ],
  data () {
    return {
      inputItem: '',
    };
  },
  computed: {
    title () {
      return this.$t(`filterSelect.historyInfo.directMailItem.${this.keyName}`);
    },
    target () {
      return this.leadListFilterParams[this.keyName];
    },
    targetDetail () {
      if (this.target == null) return '';
      return this.target.inc?.or ?? '';
    },
    value () {
      if (!this.targetDetail || this.targetDetail.length === 0) return '-';
      return this.targetDetail;
    },
  },
  methods: {
    popoverShow () {
      this.inputItem = lodash.cloneDeep(this.targetDetail);
      // MEMO: フィルター選択後、そのままInputを開いたときにフォーカスが外れるので
      setTimeout(() => this.$refs.bInput.forceFocus(), 200);
    },
    popoverHide () {
      this.$emit('hide', { inc: { or: this.inputItem } });
    },
  },
};
</script>
